"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.string.small");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var SectionHeader = function SectionHeader(_ref) {
    var title = _ref.title, subhead = _ref.subhead, children = _ref.children, className = _ref.className, id = _ref.id, _ref$small = _ref.small, small = _ref$small === void 0 ? false : _ref$small, _ref$lowercase = _ref.lowercase, lowercase = _ref$lowercase === void 0 ? false : _ref$lowercase, _ref$invert = _ref.invert, invert = _ref$invert === void 0 ? false : _ref$invert, _ref$fullWidth = _ref.fullWidth, fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth, _ref$ruleBottom = _ref.ruleBottom, ruleBottom = _ref$ruleBottom === void 0 ? false : _ref$ruleBottom, _ref$halfPadding = _ref.halfPadding, halfPadding = _ref$halfPadding === void 0 ? false : _ref$halfPadding;
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, Object.assign({
        className: className
    }, {
        id: id,
        halfPadding: halfPadding
    }), /*#__PURE__*/ react_1.default.createElement(StyledMargin, {
        fullWidth: fullWidth
    }, small && !ruleBottom && /*#__PURE__*/ react_1.default.createElement(SmallRule, {
        invert: invert
    }), /*#__PURE__*/ react_1.default.createElement(Header, Object.assign({
        dangerouslySetInnerHTML: {
            __html: title
        }
    }, {
        small: small,
        lowercase: lowercase,
        invert: invert
    })), subhead && /*#__PURE__*/ react_1.default.createElement(Subhead, Object.assign({
        dangerouslySetInnerHTML: {
            __html: subhead
        }
    }, {
        invert: invert
    })), small && ruleBottom && /*#__PURE__*/ react_1.default.createElement(SmallRuleBottom, {
        invert: invert
    }), !small && /*#__PURE__*/ react_1.default.createElement(Rule, {
        invert: invert
    }), children));
}; // Styling
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "SectionHeader__StyledMargin",
    componentId: "sc-1h2qfvj-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;padding-left:", ";padding-right:", ";", "{padding-left:", ";padding-right:", ";}"], function (props) {
    return !!props.fullWidth ? '0' : '24px';
}, function (props) {
    return !!props.fullWidth ? '0' : '24px';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.fullWidth ? '0' : '40px';
}, function (props) {
    return !!props.fullWidth ? '0' : '40px';
});
var Header = styled_components_1.default.div.withConfig({
    displayName: "SectionHeader__Header",
    componentId: "sc-1h2qfvj-1"
})(["max-width:480px;", ";text-align:center;color:", ";", "{max-width:688px;}", "{max-width:800px;}"], function (props) {
    return props.small ? _theme_1.type.h4 : props.lowercase ? _theme_1.type.h2 : _theme_1.type.h2Uppercase;
}, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.black;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'));
var Subhead = styled_components_1.default.div.withConfig({
    displayName: "SectionHeader__Subhead",
    componentId: "sc-1h2qfvj-2"
})(["max-width:420px;padding-top:7px;", " text-align:center;color:", ";", "{max-width:440px;padding-top:8px;}", "{max-width:600px;padding-top:14px;}", "{max-width:680px;padding-top:20px;}"], _theme_1.type.p, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.ink;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Rule = styled_components_1.default.div.withConfig({
    displayName: "SectionHeader__Rule",
    componentId: "sc-1h2qfvj-3"
})(["border-bottom:1px solid ", ";width:12%;padding-top:19px;", "{padding-top:23px;}", "{padding-top:29px;}", "{padding-top:37px;}"], function (props) {
    return !!props.invert ? _utils_1.rgba(_theme_1.palette.snow, 0.16) : _utils_1.rgba(_theme_1.palette.ink, 0.32);
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var SmallRule = styled_components_1.default.div.withConfig({
    displayName: "SectionHeader__SmallRule",
    componentId: "sc-1h2qfvj-4"
})(["border-top:1px solid ", ";width:100%;padding-top:10px;", "{padding-top:18px;}", "{padding-top:26px;}"], function (props) {
    return !!props.invert ? _utils_1.rgba(_theme_1.palette.snow, 0.16) : _utils_1.rgba(_theme_1.palette.ink, 0.32);
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var SmallRuleBottom = styled_components_1.default.div.withConfig({
    displayName: "SectionHeader__SmallRuleBottom",
    componentId: "sc-1h2qfvj-5"
})(["border-bottom:1px solid ", ";width:100%;padding-bottom:10px;", "{padding-bottom:18px;}", "{padding-bottom:26px;}"], function (props) {
    return !!props.invert ? _utils_1.rgba(_theme_1.palette.snow, 0.16) : _utils_1.rgba(_theme_1.palette.ink, 0.32);
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = SectionHeader;
